import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import EnergySavings from '@/comp/pages/ValueDashboardPage/EnergySavings/Main/EnergySavings';

import ReportHeaderWithIcon from '../components/ReportHeaderWithIcon';

const EnergySavingsPage = observer(() => {
  const { t } = useTranslation();

  return (
    <Container>
      <ReportHeaderWithIcon primaryTitle={t('energySavingsReportTitle')} />
      <EnergySavings className="card-item" description={t('energySavingsReportDescription')} animation={false} />
    </Container>
  );
});

const Container = styled.div`
  padding-bottom: ${({ theme: { token } }) => token.paddingXL}px;

  .card-item {
    width: auto;
    margin-left: auto;
    margin-right: auto;
    margin-top: ${({ theme: { token } }) => token.marginLG}px;

    .energy-savings-container {
      width: 620px;
      margin-left: auto;
      margin-right: auto;
    }
  }
  .description {
    margin-bottom: ${({ theme: { token } }) => token.marginXL}px;
  }
`;

export default EnergySavingsPage;
